import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { of, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { SearchEntity } from 'src/app/core/constants/dropdown-contants';
import { filePathWithProfileURL, filePathWithUserImageURL } from 'src/app/core/helpers/helperfunc';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { JobroleService } from 'src/app/core/services/job-role/job-role.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UniversityService } from 'src/app/core/services/university/university.service';
import { UsersService } from 'src/app/core/services/users/users.service';

interface UserData {
  userId: string;
  username: string;
  fullName: string;
  gender: string;
  loginStatus: string;
  homeAccess: string;
  userGroupName: string;
  jobRole: string;
  supervisor: string;
  empCabin: string;
  empSeat: string;
  empDesgination: string;
  jobDetails: string;
  universityName: string;
  JRM: string,
  URM: string,
  mobileNumber: string;
  landlineNumber: string;
  extNumber: string;
  image: string;
  aliasMail: string;
  external_email_access: string
}

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // Search and Filter Controls
  public searchControl: FormControl<string> = new FormControl<string>('');
  jobFilterCtrl = new FormControl<string>('');
  uniFilterCtrl = new FormControl<string>('');
  private _unsubscribeAll: Subject<any> = new Subject();
  searchText: string = '';
  private searchTextSubject = new Subject<string>();
  selectedJobRole: string | null = null;
  selectedUniversityName: string | null = null;
  // file_path_with_base_url = filePathWithProfileURL;
  file_path_with_base_url = filePathWithUserImageURL;
  search_entiry = SearchEntity;

  // Filter Subjects
  filteredTenant = new ReplaySubject<any>(1);
  universityFilter = new ReplaySubject<any>(1);
  private destroy$ = new Subject<void>();

  // Table Configuration
  displayedColumns: string[] = ['slNo', 'fromdate', 'todate', 'days'];
  dataSource = new MatTableDataSource<UserData>();

  // Data Storage
  originalData: UserData[] = [];
  filteredData: UserData[] = [];
  job_name: Array<{ name: string; id: string }> = [];
  uni_name: Array<{ name: string; id: string }> = [];
  userDetails: any;

  pagination_config: PaginationType = {
    size: 10,
    total: 0,
    skip: 0,
    limit: 100
  };
  store_offset: number;

  constructor(
    public dialogRef: MatDialogRef<UserListComponent>,
    private loaderService: LoaderService,
    private userService: UsersService,
    private toasterService: ToasterService,
    private _localStorageService: LocalStorageService,
    private _jobRoleService: JobroleService,
    private _univeristyService:UniversityService
  ) { }

  ngOnInit(): void {
    this.userDetails = this._localStorageService.getUser();
    this.initializeSearchSubscription();
    // this.loadData();

  }
  
  clearSelection(key: string) {
    if (key === 'searchControl') {
      console.log(this.searchControl.value)
      this.searchControl.setValue('');
    } else if (key === 'jobFilterCtrl') {
      this.selectedJobRole = ''
    } else if (key === 'uniFilterCtrl') {
      this.selectedUniversityName = ''
    }
    this.loadData();

  }
  fetchJobRoles() {
    this._jobRoleService.getJobrole({limit:100, skip:0})
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        this.handleJobRoleData(response);
      });
  }
  
  private initializeSearchSubscription(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this._unsubscribeAll)
    ).subscribe(searchText => {
      this.searchText = searchText;
      this.loadData();
      
    });
    // Subscribe to job filter changes
    this.jobFilterCtrl.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      const jobFilterValue = this.jobFilterCtrl.value;
      console.log('Job Filter Value:', jobFilterValue);
      this.filterJobRoles();
    });

    // Subscribe to university filter changes
    this.uniFilterCtrl.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.filterUniversities();
    });
    this.fetchJobRoles();
    this.initUniData();
  }
  loadData(): void {
    this.loaderService.showLoader();
    this.userService.fetchUserCallList(this.pagination_config,this.searchText,this.selectedUniversityName,this.selectedJobRole)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) =>{
        // this.handleDataResponse(response);

        // Process and store data
        this.originalData = this.convertUserData(response?.data?.data || []);
        this.filteredData = [...this.originalData];
        this.dataSource = new MatTableDataSource(this.filteredData);
        this.dataSource.paginator = this.paginator;
        this.pagination_config.total = response?.data?.total || 0;
          this.loaderService.hideLoader();
        },
        (error) => {
          this.loaderService.hideLoader();
        });

  }
   handleJobRoleData(response: any): void {
    // Initialize job roles
    const jobRoles = response?.data?.data || [];
    this.job_name = jobRoles.map((role: any) => ({
      name: role.name,
      id: role.id
    }));
    this.filteredTenant.next(this.job_name);

  }

  initUniData(){
    this._univeristyService.getUniversity({limit:900, skip:0})
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        const universities = response?.data?.data || [];
        this.uni_name = universities.map((uni: any) => ({
          name: uni.name,
          id: uni.id
        }));
        this.universityFilter.next(this.uni_name);
      });
    // Initialize universities
  }

  private convertUserData(data: any[]): UserData[] {
    const filteredData = data.filter(item => this.getBooleanStatus(item?.loginStatus) === 'Enabled');
    return filteredData.map(item => ({
      userId: item?.userId,
      username: item?.username,
      fullName: item?.fullName,
      gender: item?.gender,
      loginStatus: this.getBooleanStatus(item?.loginStatus),
      homeAccess: this.getBooleanStatus(item?.homeAccess),
      userGroupName: item?.userGroupName,
      jobRole: item?.jobRole,
      supervisor: item?.supervisorName,
      supervisorNumber: item?.supervisorMobile,
      empCabin: item?.empCabin,
      empSeat: item?.empSeat,
      empDesgination: item?.empDesgination,
      jobDetails: item?.jobDetails,

      universityWithJRMAndURM: item?.university && Array.isArray(item?.university)
      ? item.university.map(uni => {
          // Process unique JRM values
          const uniqueJRM = Array.from(
              new Set(
                  (uni?.JRM || [])
                      .filter(jrm => jrm !== "undefined undefined") // Filter out unwanted JRM values
              )
          ).join(', ');
  
          // Process URM values
          const uniqueURM = Array.from(
              new Set(
                  (uni?.URM || [])
                      .filter(urm => urm !== "undefined undefined") // Filter out unwanted URM values
              )
          ).join(', ');
  
          return {
              name: uni?.name,
              JRM: uniqueJRM || '', // Include JRM, if any
              URM: uniqueURM || '' , // Include URM, if any
              tenant: uni?.tenant
          };
      })
      : [],
  
  
      universityName: item?.university && Array.isArray(item?.university)
        ? item.university.map(uni => uni?.name).join(', ')
        : '',
        JRM:item?.university && Array.isArray(item?.university)
        ? item.university
            .map(uni => uni?.JRM?.filter(jrm => jrm !== "undefined undefined").join(', '))
            .filter(jrmString => jrmString.length > 0)
            .join(', ')
        : '',
      
        URM: item?.university && Array.isArray(item?.university)
        ? item.university
            .map(uni => uni?.URM?.filter(jrm => jrm !== "undefined undefined").join(', '))
            .filter(jrmString => jrmString.length > 0)
            .join(', ')
        : '',
      mobileNumber: item?.mobileNumber,
      landlineNumber: item?.landlineNumber,
      extNumber: item?.extNumber,
      image: item?.image,
      aliasMail: item?.aliasMail,
      external_email_access: item?.external_email_access
    }));
  }

  private getBooleanStatus(value: any): string {
    return (value === 'true' || value === true) ? 'Enabled' : 'Disabled';
  }

  filterData(): void {
    this.applyFilters();
  }

  applyFilters(): void {
    let filteredResults = [...this.originalData];

    // Apply job role filter
    if (this.selectedJobRole && this.selectedJobRole !== '') {
      filteredResults = filteredResults.filter(item =>
        item.jobRole === this.selectedJobRole
      );
    }

    // Apply university filter
    if (this.selectedUniversityName && this.selectedUniversityName !== '') {
      filteredResults = filteredResults.filter(item =>
        item.universityName.toLowerCase().includes(this.selectedUniversityName.toLowerCase())
      );
    }

    // Apply search text filter
    if (this.searchText && this.searchText.trim() !== '') {
      const searchValue = this.searchText.toLowerCase().trim();
      filteredResults = filteredResults.filter(item =>
        item.fullName.toLowerCase().includes(searchValue)
      );
    }

    // Update filtered data and data source
    this.filteredData = filteredResults;
    this.dataSource.data = filteredResults;

    // Reset paginator to first page
    if (this.paginator) {
      this.paginator.firstPage();
    }
    // this.loadData();
  }

  private filterJobRoles(): void {
    if (!this.job_name) {
      return;
    }

    let search = this.jobFilterCtrl.value;
    if (!search) {
      this.filteredTenant.next(this.job_name.slice());
      return;
    }

    search = search.toLowerCase();
    this.filteredTenant.next(
      this.job_name.filter(job => job.name.toLowerCase().includes(search))
    );
  }

  private filterUniversities(): void {
    if (!this.uni_name) {
      return;
    }

    let search = this.uniFilterCtrl.value;
    if (!search) {
      this.universityFilter.next(this.uni_name.slice());
      return;
    }

    search = search.toLowerCase();
    this.universityFilter.next(
      this.uni_name.filter(uni => uni.name.toLowerCase().includes(search))
    );
  }

  // extboundCall(extension: string): void {
  //   const userDetails = JSON.parse(this._localStorageService.getKey('user_details'));
  //   this.userService.extboundLogin({}).pipe(
  //     takeUntil(this.destroy$)
  //   ).subscribe({
  //     next: (loginRes) => {
  //       if (loginRes?.data?.status === 'Success' && loginRes?.data?.token) {
  //         const responseToken = loginRes.data.token;  // Extract the new token from the response
  //         console.log('Login successful, response token:', responseToken);

  //         // Now, use the new response token to make the extboundCall
  //         this.userService.extboundCall({
  //           outto: extension,
  //           extid: userDetails?.extension,
  //           autoanswer: 'no',
  //         }, responseToken).pipe(
  //           takeUntil(this.destroy$)
  //         ).subscribe({
  //           next: (callRes) => {
  //             if (callRes?.data?.status?.toLowerCase() === 'success') {
  //               this.toasterService.showSuccess('Success', 'Call initiated successfully');
  //             } else {
  //               this.toasterService.showError('Failed', 'Failed to make the call');
  //             }
  //           },
  //           error: () => {
  //             this.toasterService.showError('Error', 'An error occurred while making the call');
  //           }
  //         });
  //       } else {
  //         this.toasterService.showError('Login Failed', 'Failed to login, cannot make the call');
  //       }
  //     },
  //     error: () => {
  //       this.toasterService.showError('Error', 'An error occurred during login');
  //     }
  //   });
  // }

  extboundCall(extension: string): void {
  const userDetails = JSON.parse(this._localStorageService.getKey('user_details'));
  this.userService.extboundCall({
    outto: extension,
    extid: userDetails.extension,
    autoanswer: 'no',
  }).pipe(
    takeUntil(this.destroy$)
  ).subscribe({
    next: (callRes) => {
      if (callRes?.data?.status?.toLowerCase() === 'success') {
        this.toasterService.showSuccess('Success', 'Call initiated successfully');
      } else {
        this.toasterService.showError('Failed', 'Failed to make the call');
      }
    },
    error: () => {
      this.toasterService.showError('Error', 'An error occurred while making the call');
    }
  });
}



  // outboundCall(mobileNumber: string): void {
  //   const userDetails = JSON.parse(this._localStorageService.getKey('user_details'));
  //   this.userService.extboundLogin({}).pipe(
  //     takeUntil(this.destroy$)
  //   ).subscribe({
  //     next: (loginRes) => {
  //       if (loginRes?.data?.status === 'Success' && loginRes?.data?.token) {
  //         const responsesToken = loginRes.data.token;  // Extract the new token from the response
  //         console.log('Login successful, response token:', responsesToken);
  //         mobileNumber = mobileNumber.replace(/\+91\s?| /g, '');
  //         mobileNumber = `0${mobileNumber}`;
  //         // Now, use the new response token to make the extboundCall
  //         this.userService.outboundCall({
  //           outto: mobileNumber,
  //           extid: userDetails?.extension,
  //           autoanswer: 'no',
  //         }, responsesToken).pipe(
  //           takeUntil(this.destroy$)
  //         ).subscribe({
  //           next: (callRes) => {
  //             if (callRes?.data?.status === 'Success') {
  //               this.toasterService.showSuccess('Success', 'Call initiated successfully');
  //             } else {
  //               this.toasterService.showError('Failed', 'Failed to make the call');
  //             }
  //           },
  //           error: () => {
  //             this.toasterService.showError('Error', 'An error occurred while making the call');
  //           }
  //         });
  //       } else {
  //         this.toasterService.showError('Login Failed', 'Failed to login, cannot make the call');
  //       }
  //     },
  //     error: () => {
  //       this.toasterService.showError('Error', 'An error occurred during login');
  //     }
  //   });
  // }
  outboundCall(mobileNumber: string): void {
  const userDetails = JSON.parse(this._localStorageService.getKey('user_details'));
  mobileNumber = mobileNumber.replace(/\+91\s?| /g, '');
  mobileNumber = `10${mobileNumber}`;

  this.userService.outboundCall({
    outto: mobileNumber,
    extid: userDetails.extension,
    autoanswer: 'no',
  }).pipe(
    takeUntil(this.destroy$)
  ).subscribe({
    next: (callRes) => {
      if (callRes?.data?.status === 'Success') {
        this.toasterService.showSuccess('Success', 'Call initiated successfully');
      } else {
        this.toasterService.showError('Failed', 'Failed to make the call');
      }
    },
    error: () => {
      this.toasterService.showError('Error', 'An error occurred while making the call');
    }
  });
}



  close(val?: any): void {
    this.dialogRef.close(val);
  }

  getEmails(aliasMail: string): string[] {
    try {
      // Parse the aliasMail string into an array and extract only the 'mail' field
      const emails = aliasMail ? JSON.parse(aliasMail) : [];
      return emails.map((emailObj: { mail: string }) => emailObj.mail);
    } catch (error) {
      console.error('Error parsing emails:', error);
      return [];
    }
  }
  

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  onScroll(){
    this.pagination_config.skip = 0;
    this.pagination_config.limit += 100;
    this.store_offset += this.pagination_config.limit;
    this.loadData();
  }
}